import React from 'react';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  UncontrolledDropdown,
} from 'reactstrap';
import ActionButton from '../../../../../../../../Components/Common/ActionButton';
import StatusBadge from '../../../../../../../../Components/Common/StatusBadge';

export const OFFER_STATUS_FILTER_OPTIONS = [
  { value: 'compliant', label: 'Compliant', group: 'kind' },
  { value: 'counter', label: 'Counter', group: 'kind' },
  { value: 'late', label: 'Late Submit', group: 'late' },
  { value: 'on-time', label: 'On Time', group: 'late' },
];

export const filterRowsByOfferStatus = (rows = [], selected = []) => {
  if (!selected.length) return rows;

  const kindSelected = selected.filter(
    value => value === 'compliant' || value === 'counter'
  );
  const lateSelected = selected.filter(
    value => value === 'late' || value === 'on-time'
  );

  return rows.filter(row => {
    if (kindSelected.length) {
      const kind = row.kind === 'counter' ? 'counter' : 'compliant';
      if (!kindSelected.includes(kind)) return false;
    }
    if (lateSelected.length) {
      const lateKey =
        row.bidder?.isLateSubmission === true ? 'late' : 'on-time';
      if (!lateSelected.includes(lateKey)) return false;
    }
    return true;
  });
};

export const OfferStatusBadges = ({ isCounter, isLateSubmission = false }) => (
  <div className='d-flex flex-column align-items-start gap-1'>
    {isCounter ? (
      <StatusBadge tone='warning' label='Counter' size='sm' />
    ) : (
      <StatusBadge tone='primary' label='Compliant' size='sm' />
    )}
    {isLateSubmission === true ? (
      <StatusBadge tone='danger' label='Late Submit' size='sm' />
    ) : null}
  </div>
);

export const OfferSelectAllBar = ({
  onSelectAll,
  onClear,
  selectedCount = 0,
  disabled = false,
}) => (
  <div className='d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3 p-3 border rounded bg-light'>
    <div className='me-auto'>
      <div className='fw-semibold text-dark fs-13 mb-1'>
        Request Improvement selection
      </div>
      <p className='text-muted small mb-0'>
        Centang offer per baris, atau Select all offers. Clear selection hanya
        melepas pilihan baru — status Requested tetap tercentang.
      </p>
      {selectedCount > 0 ? (
        <p className='text-primary small fw-semibold mb-0 mt-1'>
          {selectedCount} offer selected
        </p>
      ) : null}
    </div>
    <div className='d-flex flex-wrap gap-2'>
      <ActionButton
        variant='secondary'
        icon='ri-checkbox-multiple-line'
        disabled={disabled}
        onClick={onSelectAll}
      >
        Select all offers
      </ActionButton>
      <ActionButton
        variant='tertiary'
        icon='ri-close-line'
        disabled={disabled || selectedCount === 0}
        onClick={onClear}
      >
        Clear selection
      </ActionButton>
    </div>
  </div>
);

export const OfferStatusFilter = ({ value = [], onChange }) => {
  const selected = Array.isArray(value) ? value : [];
  const toggleValue = next => {
    onChange(
      selected.includes(next)
        ? selected.filter(item => item !== next)
        : [...selected, next]
    );
  };

  const summary = selected.length
    ? selected
        .map(
          item =>
            OFFER_STATUS_FILTER_OPTIONS.find(option => option.value === item)
              ?.label
        )
        .filter(Boolean)
        .join(', ')
    : 'All';

  return (
    <UncontrolledDropdown onClick={event => event.stopPropagation()}>
      <DropdownToggle
        caret
        color='light'
        size='sm'
        className='border form-select-sm py-0 px-2 text-start text-truncate w-100'
        style={{ minHeight: '28px', maxWidth: '100%' }}
        title={summary}
      >
        {summary}
      </DropdownToggle>
      <DropdownMenu
        container='body'
        style={{ minWidth: '11rem' }}
        onClick={event => event.stopPropagation()}
      >
        {OFFER_STATUS_FILTER_OPTIONS.map(option => (
          <DropdownItem
            key={option.value}
            toggle={false}
            className='d-flex align-items-center gap-2'
            onClick={() => toggleValue(option.value)}
          >
            <Input
              type='checkbox'
              className='form-check-input m-0'
              checked={selected.includes(option.value)}
              readOnly
              aria-hidden
            />
            <span className='fs-12'>{option.label}</span>
          </DropdownItem>
        ))}
        {selected.length ? (
          <>
            <DropdownItem divider />
            <DropdownItem
              className='fs-12 text-muted'
              onClick={() => onChange([])}
            >
              Clear filters
            </DropdownItem>
          </>
        ) : null}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};
